(function () {
  'use strict';

  var container = document.getElementById('return-form-container');
  if (!container) return;

  var lookupForm = document.getElementById('return-lookup-form');
  var submitForm = document.getElementById('return-submit-form');
  var itemsEl = document.getElementById('return-items');
  var summaryEl = document.getElementById('return-order-summary');
  var successEl = document.getElementById('return-success');
  var errorEl = document.getElementById('return-error');
  var backBtn = document.getElementById('return-back');

  var lookupUrl = container.dataset.lookupUrl || '';
  var submitUrl = container.dataset.submitUrl || '';
  var siteLang = container.dataset.lang || '';
  var store = container.dataset.store || 'mayuri';

  var i18n = {};
  try {
    i18n = JSON.parse(document.getElementById('return-form-i18n').textContent);
  } catch (e) {
    i18n = {};
  }

  // Données de la commande retrouvée (renseignées après lookup réussi)
  var order = null;

  // --- Étape 1 : lookup ---
  lookupForm.addEventListener('submit', function (e) {
    e.preventDefault();
    hideMessages();

    if (!lookupForm.checkValidity()) {
      lookupForm.reportValidity();
      return;
    }
    if (!lookupUrl) {
      showError(i18n.error_generic);
      return;
    }

    var email = lookupForm.querySelector('[name="email"]').value.trim();
    var orderNumber = lookupForm.querySelector('[name="order_number"]').value.trim();

    setLoading(true);

    // Multipart FormData (pas de JSON) : requête CORS "simple", aucun preflight —
    // même pattern que les formulaires réparation / sur-mesure en prod.
    var lookupFd = new FormData();
    lookupFd.append('email', email);
    lookupFd.append('order_number', orderNumber);
    lookupFd.append('store', store);

    fetch(lookupUrl, {
      method: 'POST',
      body: lookupFd
    })
      .then(function (res) {
        if (!res.ok) throw new Error('lookup_failed');
        return res.json();
      })
      .then(function (data) {
        setLoading(false);
        if (!data || data.found !== true || !Array.isArray(data.items) || data.items.length === 0) {
          showError(i18n.lookup_not_found);
          return;
        }
        order = {
          email: email,
          order_number: data.order_number || orderNumber,
          customer_name: data.customer_name || '',
          items: data.items
        };
        renderItems(data.items);
        if (summaryEl && i18n.order_summary) {
          summaryEl.textContent = i18n.order_summary.replace('{order}', order.order_number);
        }
        lookupForm.classList.add('return-form__step--hidden');
        submitForm.classList.remove('return-form__step--hidden');
        scrollToTop();
      })
      .catch(function () {
        setLoading(false);
        showError(i18n.error_generic);
      });
  });

  function renderItems(items) {
    itemsEl.innerHTML = '';
    items.forEach(function (item, idx) {
      var wrap = document.createElement('div');
      wrap.className = 'return-form__item';

      var head = document.createElement('label');
      head.className = 'return-form__item-head';

      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.dataset.index = idx;
      cb.className = 'return-form__item-check';

      head.appendChild(cb);

      if (item.image) {
        var img = document.createElement('img');
        img.className = 'return-form__item-thumb';
        img.src = item.image;
        img.alt = item.title || '';
        head.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'return-form__item-info';

      var title = document.createElement('span');
      title.className = 'return-form__item-title';
      title.textContent = item.title || '';
      info.appendChild(title);

      var variantText = [];
      if (item.variant_title && item.variant_title !== 'Default Title') variantText.push(item.variant_title);
      if (item.quantity && item.quantity > 1) variantText.push('×' + item.quantity);
      if (variantText.length) {
        var variant = document.createElement('span');
        variant.className = 'return-form__item-variant';
        variant.textContent = variantText.join(' · ');
        info.appendChild(variant);
      }

      head.appendChild(info);
      wrap.appendChild(head);

      // Motif (visible une fois l'article coché)
      var reasonWrap = document.createElement('div');
      reasonWrap.className = 'return-form__item-reason';

      var select = document.createElement('select');
      select.className = 'select return-form__item-reason-select';

      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.selected = true;
      placeholder.disabled = true;
      placeholder.textContent = i18n.item_reason || 'Motif';
      select.appendChild(placeholder);

      var reasons = i18n.reasons || {};
      Object.keys(reasons).forEach(function (key) {
        var opt = document.createElement('option');
        opt.value = key;
        opt.textContent = reasons[key];
        select.appendChild(opt);
      });

      reasonWrap.appendChild(select);
      wrap.appendChild(reasonWrap);

      cb.addEventListener('change', function () {
        if (cb.checked) {
          wrap.classList.add('is-selected');
          select.setAttribute('required', '');
        } else {
          wrap.classList.remove('is-selected');
          select.removeAttribute('required');
          select.value = '';
        }
      });

      itemsEl.appendChild(wrap);
    });
  }

  // --- Étape 2 : soumission ---
  submitForm.addEventListener('submit', function (e) {
    e.preventDefault();
    hideMessages();

    var checks = itemsEl.querySelectorAll('.return-form__item-check');
    var selected = [];
    for (var i = 0; i < checks.length; i++) {
      if (checks[i].checked) {
        var idx = parseInt(checks[i].dataset.index, 10);
        var itemWrap = checks[i].closest('.return-form__item');
        var reasonSel = itemWrap.querySelector('.return-form__item-reason-select');
        selected.push({
          index: idx,
          item: order.items[idx],
          reason: reasonSel ? reasonSel.value : ''
        });
      }
    }

    if (selected.length === 0) {
      showError(i18n.no_item_selected);
      return;
    }
    for (var j = 0; j < selected.length; j++) {
      if (!selected[j].reason) {
        showError(i18n.no_reason_selected);
        return;
      }
    }

    if (!submitForm.checkValidity()) {
      submitForm.reportValidity();
      return;
    }
    if (!submitUrl) {
      showError(i18n.error_generic);
      return;
    }

    var resolutionEl = submitForm.querySelector('[name="resolution"]:checked');
    var comment = submitForm.querySelector('[name="comment"]').value.trim();

    var items = selected.map(function (s) {
      return {
        id: s.item.id || null,
        variant_id: s.item.variant_id || null,
        title: s.item.title || '',
        variant_title: s.item.variant_title || '',
        quantity: s.item.quantity || 1,
        sku: s.item.sku || '',
        reason: s.reason
      };
    });

    setLoading(true);

    // Multipart FormData : scalaires en champs, articles en `items` (JSON string).
    var fd = new FormData();
    fd.append('email', order.email);
    fd.append('order_number', order.order_number);
    fd.append('customer_name', order.customer_name || '');
    fd.append('resolution', resolutionEl ? resolutionEl.value : '');
    fd.append('comment', comment);
    fd.append('items', JSON.stringify(items));
    fd.append('lang', siteLang);
    fd.append('store', store);

    fetch(submitUrl, {
      method: 'POST',
      body: fd
    })
      .then(function (res) {
        if (!res.ok) throw new Error('submit_failed');
        return res.json().catch(function () { return {}; });
      })
      .then(function () {
        setLoading(false);
        submitForm.style.display = 'none';
        successEl.style.display = 'block';
        scrollToTop();
      })
      .catch(function () {
        setLoading(false);
        showError(i18n.error_generic);
      });
  });

  // --- Retour à l'étape 1 ---
  backBtn.addEventListener('click', function () {
    hideMessages();
    submitForm.classList.add('return-form__step--hidden');
    lookupForm.classList.remove('return-form__step--hidden');
    scrollToTop();
  });

  function setLoading(on) {
    container.classList.toggle('is-loading', on);
  }

  function showError(msg) {
    var bannerContent = errorEl.querySelector('.banner__content, p, span') || errorEl.querySelector('.banner');
    if (bannerContent) bannerContent.textContent = msg || i18n.error_generic || '';
    errorEl.style.display = 'block';
    successEl.style.display = 'none';
  }

  function hideMessages() {
    errorEl.style.display = 'none';
    successEl.style.display = 'none';
  }

  function scrollToTop() {
    window.scrollTo({ top: container.offsetTop - 100, behavior: 'smooth' });
  }
})();
